import React from "react";
import isEqual from "lodash/isEqual";

const Chartist = process.browser && require("chartist");

const BASE_OPTIONS = {
  donut: true,
  donutSolid: true,
  donutWidth: "15%",
  height: 250,
  ignoreEmptyValues: false,
  showLabel: false,
  width: "100%",
};

class NutrientsChart extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    require("chartist-plugin-fill-donut");
    const { data, donutContent } = this.generateChartData();
    const { height, providedId, width } = this.props;
    if (height) {
      BASE_OPTIONS.height = height;
    }
    if (width) {
      BASE_OPTIONS.width = width;
    }

    const options = Object.assign({}, BASE_OPTIONS, {
      plugins: [
        Chartist.plugins.fillDonut({
          items: [
            {
              content: donutContent,
            },
          ],
        }),
      ],
    });

    this.chartObject = new Chartist.Pie(
      `#${providedId || "donut-chart"}`,
      data,
      options
    );
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.dayStats, this.props.dayStats) ||
      !isEqual(prevProps.targetData, this.props.targetData)
    ) {
      this.updateChart();
    }
  }

  getNutrientsData() {
    const { dayStats, targetData } = this.props;
    const { carbs = 0, fats = 0, proteins = 0 } = dayStats.nutrients;
    const proteinsDays = dayStats.proteinsDays || 1;
    const carbsDays = dayStats.carbsDays || 1;
    const fatsDays = dayStats.fatsDays || 1;
    const targetCalories = targetData
      ? Math.round(targetData.targetCalories) || 0
      : 0;

    const proteinsKcal = Math.round((proteins * 4) / proteinsDays);
    const carbsKcal = Math.round((carbs * 4) / carbsDays);
    const fatsKcal = Math.round((fats * 9) / fatsDays);
    const calories = Math.round(proteinsKcal + carbsKcal + fatsKcal);
    const caloriesLeft = Math.round(targetCalories - calories);

    const proteinPercent = Math.round((proteinsKcal / calories) * 100) || 0;
    const carbsPercent = Math.floor((carbsKcal / calories) * 100) || 0;
    const fatPercent = Math.round((fatsKcal / calories) * 100) || 0;

    return {
      proteinsKcal,
      carbsKcal,
      fatsKcal,
      calories,
      caloriesLeft,
      proteinPercent,
      carbsPercent,
      fatPercent,
    };
  }

  generateChartData() {
    const { targetData } = this.props;
    const { proteinsKcal, carbsKcal, fatsKcal, calories, caloriesLeft } =
      this.getNutrientsData();

    const data = {
      series: [
        { value: proteinsKcal, className: "proteins" },
        { value: carbsKcal, className: "carbs" },
        { value: fatsKcal, className: "fats" },
      ],
    };

    const targetCalories =
      targetData && targetData.targetCalories
        ? `<span class="kcal-target">/${Math.round(
            targetData.targetCalories
          )}</span>`
        : "";
    const left =
      targetData && targetData.targetCalories
        ? `
          <div>
            <span class="kcal-left${caloriesLeft < 0 ? " over" : ""}">
              ${Math.abs(caloriesLeft)} ${caloriesLeft < 0 ? "over" : "left"}
            </span>
          </div>
        `
        : "";

    const donutContent = `
    <div class="donut-content">
      <div>
        <span class="kcal-value">${calories}</span>
        ${targetCalories}
      </div>

      <div class="kcal-label">kCal</div>
      ${left}
    </div>`;

    return { data, donutContent };
  }

  updateChart() {
    const { data, donutContent } = this.generateChartData();
    const options = Object.assign({}, BASE_OPTIONS, {
      fillDonutOptions: { items: [{ content: donutContent }] },
    });
    this.chartObject.update(data, options);
  }

  renderLegend() {
    const { proteinPercent, carbsPercent, fatPercent } =
      this.getNutrientsData();

    return (
      <div className="legend-container">
        {!!proteinPercent && (
          <div className="legend-item">
            <div className="legend-indicator protein" />
            <span>{proteinPercent}% Protein</span>
          </div>
        )}
        {!!carbsPercent && (
          <div className="legend-item">
            <div className="legend-indicator carbs" />
            <span>{carbsPercent}% Carbs</span>
          </div>
        )}
        {!!fatPercent && (
          <div className="legend-item">
            <div className="legend-indicator fat" />
            <span>{fatPercent}% Fat</span>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="graph-container donut">
        <div
          className="donut-chart"
          id={this.props.providedId || "donut-chart"}
        />
        {this.renderLegend()}
      </div>
    );
  }
}

export default NutrientsChart;
